export default "__VITE_ASSET__BxX94H7a__"